<template>
  <main>
    <section>
      <user-workload-to-company-modal />
      <incurred-expense-modal />
      <span><strong>Atividades desenvolvidas | </strong>
              {{ formatDateBr(date) }} |
              {{ secondsToDate(workload.worked_total) }} de
              {{ secondsToDate(workload.workload_total) }}
          </span>
      <div class="progress">
        <div class="progress-bar text-shadow" role="progressbar"
             :style="'width:'+workload.percentage_worked+'%; background-color:'+((workload.workload_total - workload.tolerance > workload.worked_total) ? 'red':'green')">
          {{ Math.abs(workload.percentage_worked).toFixed(2) }} %
        </div>
      </div>

      <form v-on:submit.prevent="create" class="row task-made-form mt-4">
        <div class="form-group col-md-1">
          <date-picker
            v-model="date"
            format="DD/MM/YY"
            v-mask="'##/##/##'"
            v-on:change="loadWorkload"
          >
          </date-picker>
        </div>
        <div class="form-group input-form time-form col-md-2">
          <input
            class="form-control"
            v-mask="'##:##'"
            type="text"
            v-model="started_at"
            placeholder="Inicio"
            name="started_at"
            id="started_at"
            ref="started_at">
          <input
            class="form-control"
            v-mask="'##:##'"
            type="text"
            v-model="finished_at"
            placeholder="Fim"
            name="finished_at"
            id="finished_at"
            ref="finished_at">
        </div>
        <div class="form-group col-md-2 input-form">
          <v-select
            :reduce="task => task.id"
            placeholder="Atividade"
            label="name"
            v-model="task_id"
            :options="tasks"
            v-if="tasks"/>
        </div>
        <div class="form-group col-md-2 input-form">
          <v-select
            :reduce="taskType => taskType.id"
            placeholder="Classificação"
            label="name"
            v-model="task_type_id"
            :options="taskTypes"
            v-if="taskTypes"/>
        </div>
        <div class="form-group col-md-2 input-form">
          <v-select
            :reduce="customer => customer.id"
            placeholder="Cliente"
            label="name"
            v-model="customer_id"
            :options="customers"
            v-if="customers"
            :disabled="Boolean(customerServiceId)"
          />
        </div>
        <div class="form-group col-md-2 input-form">
          <input
            class="form-control"
            type="text"
            v-model="note"
            placeholder="Observação"
            name="note"
            id="note">
        </div>
        <div class="d-flex flex-row col-md-1 gap-2">
          <button type="submit" class="btn btn-success">Salvar</button>
          <button v-if="customerServiceId" v-on:click="restForm" type="button" class="btn btn-danger">Cancelar</button>
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            title="Horas por empresa"
            v-on:click="resume"
          >
            <i class="far fa-building"></i>
          </button>
        </div>
      </form>
    </section>

    <section class="mt-3">
      <div class="accordion" id="accordionFilters" style="margin-top: 5px">
        <div class="accordion-item">
          <h5 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed"
                    :style="'color:' + (loadStringFilters ? 'red' : 'blue')"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne">
              {{ loadStringFilters ? 'Filtros ativos' : 'Filtros' }}
            </button>
          </h5>
          <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
               data-bs-parent="#accordionFilters">
            <div class="accordion-body">
              <div class="row task-made-form">
                <div class="form-group col-md-1">
                  <date-picker
                    v-model="filters.startDate"
                    format="DD/MM/YY"
                    v-mask="'##/##/##'"
                    v-on:change="builderFilters"
                  >
                  </date-picker>
                </div>
                <div class="form-group col-md-1">
                  <date-picker
                    v-model="filters.endDate"
                    format="DD/MM/YY"
                    v-mask="'##/##/##'"
                    v-on:change="builderFilters"
                  >
                  </date-picker>
                </div>
                <div class="form-group col-md-2 input-form">
                  <v-select
                    :reduce="task =>task.id"
                    placeholder="Atividade"
                    label="name"
                    v-model="filters.task"
                    :options="tasks"
                    v-if="tasks"
                    v-on:input="builderFilters"
                  />
                </div>
                <div class="form-group col-md-2 input-form">
                  <v-select
                    :reduce="taskType => taskType.id"
                    placeholder="Classificação"
                    label="name"
                    v-model="filters.taskType"
                    :options="taskTypes"
                    v-if="taskTypes"
                    v-on:input="builderFilters"
                  />
                </div>
                <div class="form-group col-md-2 input-form">
                  <v-select
                    :reduce="customer => customer.id"
                    placeholder="Cliente"
                    label="name"
                    v-model="filters.customer"
                    :options="customers"
                    v-if="customers"
                    v-on:input="builderFilters"
                  />
                </div>
                <div class="form-group col-md-2 input-form">
                  <input
                    class="form-control"
                    type="text"
                    v-model="filters.note"
                    placeholder="Observação"
                    name="note"
                    v-on:blur="builderFilters"
                    v-on:keyup="search"
                  >
                </div>
                <div class="form-group col-md-1">
                  <button v-on:click="clearFilters" class="form-control btn btn-danger">Limpar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mt-3" v-if="customerServices.length">
      <div class="accordion" id="accordionCustomerServices">
        <div class="accordion-item">
          <h5 class="accordion-header">
            <button
              class="accordion-button collapsed"
              style="color: blue;"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseService"
              aria-expanded="false"
              aria-controls="collapseService"
            >
              Ticket em aberto
            </button>
          </h5>
          <div id="collapseService" class="accordion-collapse collapse" data-bs-parent="#accordionCustomerServices">
            <div class="accordion-body">
              <div class="table-responsive">
                <table class="table table-striped tasks-table">
                  <thead>
                  <tr>
                    <th>Criado em</th>
                    <th>Cliente</th>
                    <th>Atividade</th>
                    <th>Tipo de trabalho</th>
                    <th>Observação</th>
                    <th>Status</th>
                    <th>Açoes</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="customerService in customerServices" :key="customerService.id">
                    <td class="tasks-td-large">{{ formatDateBrToView(customerService.created_at) }}</td>
                    <td class="tasks-td-large">{{ customerService.customer_name }}</td>
                    <td class="tasks-td-large">{{ customerService.task_name }}</td>
                    <td class="tasks-td-large">{{ customerService.task_type_name }}</td>
                    <td class="tasks-td-large" :title="customerService.note">{{ customerService.note }}</td>
                    <td class="tasks-td-large">{{ renameStatus(customerService.status) }}</td>
                    <td class="tasks-td-small text-center">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <span v-if="customerService.is_fixed_value" class="badge bg-primary w-100">FIXO</span>
                        <button
                          v-on:click="startCustomerService(customerService)"
                          :title="customerService.status === 'in_progress' ? 'Adicionar mais atividades' : ''"
                          v-if="(customerService.status === 'pending' || customerService.status === 'in_progress') && !customerService.is_fixed_value"
                          class="btn btn-outline-info btn-sm w-100"
                          type="button"
                        >
                          {{ customerService.status === 'pending' ? 'Iniciar' : '+' }}
                        </button>
                        <button
                          v-if="customerService.is_fixed_value && customerService.status === 'pending'"
                          v-on:click="startCustomerServiceStatus(customerService.id)"
                          class="btn btn-outline-info btn-sm w-100"
                          type="button"
                        >
                          Iniciar
                        </button>
                        <button
                          v-if="customerService.status === 'in_progress'"
                          v-on:click="finishedCustomerService(customerService.id)"
                          class="btn btn-outline-success btn-sm w-100"
                          type="button"
                        >
                          Finalizar
                        </button>
                        <button
                          title="Despesas"
                          v-if="customerService.status === 'in_progress'"
                          v-on:click="incurredExpense(customerService)"
                          class="btn btn-outline-primary btn-sm w-100"
                          type="button"
                        >
                          $
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="d-flex flex-column mt-4 table-responsive">
      <table class="table table-striped tasks-table">
        <thead>
        <tr>
          <th>Data</th>
          <th>Inicio</th>
          <th>Fim</th>
          <th>Total</th>
          <th>Atividade</th>
          <th>Tipo de Trabalho</th>
          <th>Cliente</th>
          <th>Observações</th>
          <th width="120px">Ações</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th>Total</th>
          <th></th>
          <th></th>
          <th>{{ secondsToDate(total_spent) }}</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <tr v-for="taskMade in tasksMade" :key="taskMade.id">
          <td class="tasks-td-small">
            <date-picker
              style="max-width: 115px"
              v-model="taskMade.made_at"
              format="DD/MM/YY"
              v-mask="'##/##/##'"
              v-on:change="edit(taskMade)"
            >
            </date-picker>
          </td>
          <td class="tasks-td-small"><input
            :ref="'started_at-' + taskMade.id"
            v-mask="'##:##'"
            class="form-control hide-input"
            v-model="taskMade.started_at"
            v-on:blur="edit(taskMade)"
          ></td>
          <td class="tasks-td-small"><input
            :ref="'finished_at-' + taskMade.id"
            v-mask="'##:##'"
            class="form-control hide-input"
            v-model="taskMade.finished_at"
            v-on:change="edit(taskMade)"
          ></td>
          <td class="tasks-td-small"><input
            class="form-control hide-input"
            :value="secondsToDate(taskMade.time_spent)"
          ></td>
          <td class="tasks-td-large">
            <v-select
              :reduce="task => task.id"
              placeholder="Atividade"
              label="name"
              v-model="taskMade.task.data.id"
              :options="tasks"
              v-if="tasks"
              v-on:input="edit(taskMade)"
            />
          </td>
          <td class="tasks-td-large">
            <v-select
              :reduce="taskType => taskType.id"
              placeholder="Classificação"
              label="name"
              v-model="taskMade.task_type.data.id"
              :options="taskTypes"
              v-if="taskTypes"
              v-on:input="edit(taskMade)"
            />
          </td>
          <td class="tasks-td-large">
            <v-select
              style="white-space: nowrap"
              :reduce="customer => customer.id"
              placeholder="Cliente"
              label="name"
              v-model="taskMade.customer.data.id"
              :options="customers"
              v-if="customers"
              v-on:input="edit(taskMade)"
              :disabled="Boolean(taskMade.customer_service_id)"
            />
          </td>
          <td class="tasks-td-large"><input
            class="form-control hide-input"
            v-model="taskMade.note"
            v-on:change="edit(taskMade)"
          ></td>
          <td>
            <button
              title="replicar"
              class="btn btn-primary"
              v-on:click="replay(taskMade)"
            ><i class="fas fa-reply"></i></button>
            <button
              title="excluir"
              class="btn btn-danger"
              v-on:click="destroy(taskMade.id)"
            ><i class="far fa-trash-alt"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </section>
  </main>
</template>

<script>
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import UserWorkloadToCompanyModal from '../components/UserWorkloadToCompaniesModal'
import IncurredExpenseModal from '../components/IncurredExpenseModal'
import {mapGetters} from 'vuex'
import Vue from 'vue'

export default {
  name: 'TasksMade',
  components: {
    DatePicker,
    UserWorkloadToCompanyModal,
    IncurredExpenseModal
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  data() {
    return {
      eventHub: new Vue(),
      tasks: false,
      taskTypes: false,
      customers: false,
      errors: {},
      date: new Date(),
      started_at: '',
      finished_at: '',
      task_id: '',
      task_type_id: '',
      customer_id: '',
      note: '',
      tasksMade: {},
      workload: '',
      worked: '',
      filters: {},
      stringFilters: null,
      loadStringFilters: false,
      searchTimeout: null,
      total_spent: 0,
      customerServices: [],
      customerServiceId: false,
    }
  },
  mounted() {
    this.index();
    this.loadWorkload();
    this.loadFormOptions();
    this.loadFilters();
    this.loadCustomerServices();
  },
  provide() {
    return {
      eventHub: this.eventHub
    }
  },
  methods: {
    search() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.builderFilters()
      }, 1000)
    },
    loadFilters() {
      this.filters = {
        startDate: new Date(),
        endDate: new Date(),
        task: '',
        taskType: '',
        customer: '',
        note: ''
      }
    },
    restForm() {
      this.started_at = '';
      this.finished_at = '';
      this.note = '';
      this.customer_id = '';
      this.task_id = '';
      this.task_type_id = '';
      this.customerServiceId = false;
      this.errors = {};
    },
    loadCustomerServices() {
      axios
        .get(`/api/customer-service?userId=${this.user.id}&task-made=1`)
        .then(({data}) => this.customerServices = data.data);
    },
    index() {
      if (!this.loadStringFilters) {
        this.stringFilters = 'startDate=' + this.formatDate(this.date)
          + '&endDate=' + this.formatDate(this.date)
      }
      axios
        .get('/api/tasks_made?' + this.stringFilters)
        .then((response) => {
          this.tasksMade = response.data.data
          for (let index in this.tasksMade) {
            this.tasksMade[index].made_at = new Date(this.tasksMade[index].made_at + ' 12:00:00')
          }
          this.total_spent = 0
          this.totalTimeSpent(this.tasksMade)
        })
      this.$refs.finished_at.focus()

    },
    totalTimeSpent(tasks) {
      for (let i in tasks) {
        this.total_spent += tasks[i].time_spent
      }
    },
    formatDate(date) {
      return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
    },
    formatDateBr(date) {
      return (("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + date.getFullYear());
    },
    formatDateBrToView(originalDate) {
      const data = new Date(originalDate);
      let timezoneOffset = -180;
      data.setMinutes(data.getMinutes() - timezoneOffset);
      return data.toLocaleDateString("pt-BR");
    },
    renameStatus(status) {
      if (status === 'pending')
        return 'Pendente';
      if (status === 'in_progress')
        return 'Em Andamento';
      if (status === 'completed')
        return 'Finalizado';

      return "error";
    },
    secondsToDate(seconds) {
      if (isNaN(seconds)) {
        return '00:00:00'
      }
      let hours = Math.floor(seconds / 3600)
      seconds %= 3600
      let minutes = Math.floor(seconds / 60)
      seconds = seconds % 60

      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
    },
    create() {
      let formData = {
        started_at: this.started_at,
        finished_at: this.finished_at,
        made_at: this.formatDate(this.date),
        note: this.note,
        customer_id: this.customer_id,
        task_id: this.task_id,
        task_type_id: this.task_type_id
      };

      if (this.customerServiceId) {
        formData.customer_service_id = this.customerServiceId;
      }

      axios
        .post('/api/tasks_made', formData)
        .then(() => {
          if (this.customerServiceId) {
            this.loadCustomerServices();
          }
          this.restForm();
          this.index();
          this.loadWorkload();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.fail();
        });
    },
    edit(task) {
      let formData = {
        started_at: task.started_at,
        finished_at: task.finished_at,
        made_at: this.formatDate(task.made_at),
        note: task.note,
        customer_id: task.customer.data.id,
        task_id: task.task.data.id,
        task_type_id: task.task_type.data.id
      };

      if (this.customerServiceId) {
        formData.customer_service_id = this.customerServiceId;
      }

      axios
        .put(`/api/tasks_made/${task.id}`, formData)
        .then(() => {
          this.index();
          this.restForm();
          this.loadWorkload();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.fail();
        });
    },
    startCustomerService(customerService) {
      this.customerServiceId = customerService.id
      this.started_at = ''
      this.finished_at = ''
      this.note = customerService.note
      this.customer_id = customerService.customer_id
      this.task_id = customerService.task_id
      this.task_type_id = customerService.task_type_id
      this.$refs.started_at.focus()
    },
    startCustomerServiceStatus(id) {
      this.$confirm({
        message: 'Deseja iniciar o trabalho para este ticket de valor fixo?',
        button: {
          no: 'Não',
          yes: 'Sim',
        },
        callback: confirm => {
          if (confirm) {
            axios
              .patch(`/api/customer-service/${id}/start`)
              .then(() => {
                this.$toast.success("Ticket iniciado com sucesso!");
                this.loadCustomerServices();
                this.index();
                this.loadWorkload();
              })
              .catch((error) => {
                this.errors = error.response.data.errors;
                this.fail();
              })
          }
        }
      });
    },
    finishedCustomerService(id) {
      this.$confirm({
        message: 'Tem certeza que deseja finalizar o Ticket?',
        button: {
          no: 'Não',
          yes: 'Sim',
        },
        callback: confirm => {
          if (confirm) {
            axios
              .patch(`/api/customer-service/${id}/finish`)
              .then(() => {
                this.$toast.success("Ticket finalizado com sucesso!");
                this.loadCustomerServices();
                this.index();
                this.loadWorkload();
              })
              .catch((error) => {
                this.errors = error.response.data.errors;
                this.fail();
              })
          }
        }
      });
    },
    fail() {
      let message = ''
      for (let i in this.errors) {
        message = this.errors[i] + '<br />' + message
      }
      this.$swal({
        title: 'Ops...',
        text: message,
        icon: 'error',
        html: message
      }).then(() => {
        this.index()
      });
    },
    destroy(id) {
      this.$confirm(
        {
          message: `Tem certeza que deseja excluir?`,
          button: {
            no: 'Não',
            yes: 'Sim'
          },
          callback: confirm => {
            if (confirm) {
              axios
                .delete(`/api/tasks_made/${id}`)
                .then(() => {
                  this.index();
                  this.loadCustomerServices();
                  this.loadWorkload();
                })
                .catch((error) => {
                  this.errors = error.response.data.errors;
                  this.fail();
                });
            }
          }
        }
      )
    },
    replay(task) {
      this.started_at = ''
      this.finished_at = ''
      this.date = task.made_at
      this.note = task.note
      this.customer_id = task.customer.data.id,
        this.task_id = task.task.data.id,
        this.task_type_id = task.task_type.data.id
      this.$refs.started_at.focus()
    },
    loadFormOptions() {
      axios
        .get('/api/tasks')
        .then((response) => {
          this.tasks = response.data
        })
      axios
        .get('/api/task_types')
        .then((response) => {
          this.taskTypes = response.data.data
        })
      axios
        .get('/api/customers')
        .then((response) => {
          this.customers = response.data.data
        })
    },
    loadWorkload() {
      if (!this.loadStringFilters) {
        this.index()
      }
      axios
        .get('/api/tasks_made/workload?startDate=' + this.formatDate(this.date) + '&endDate=' + this.formatDate(this.date))
        .then((response) => {
          this.workload = response.data
          if (this.workload.max_hour) {
            this.started_at = this.workload.max_hour.finished_at
          } else {
            this.started_at = ''
          }
        })
      this.$refs.finished_at.focus()
    },
    builderFilters() {
      let filters = {
        startDate: this.formatDate(this.filters.startDate),
        endDate: this.formatDate(this.filters.endDate)
      }

      if (this.filters.task) {
        filters.task = this.filters.task
      }

      if (this.filters.taskType) {
        filters.taskType = this.filters.taskType
      }

      if (this.filters.customer) {
        filters.customer = this.filters.customer
      }

      if (this.filters.note) {
        filters.note = this.filters.note
      }
      this.builderFiltersString(filters)
    },
    builderFiltersString(filters) {
      let filterString = ''
      for (let filter in filters) {
        if (filters[filter] != null) {
          filterString += filter + '=' + filters[filter] + '&'
        }
      }
      this.stringFilters = filterString.substring(0, filterString.length - 1)
      this.loadStringFilters = true
      this.index()
    },
    clearFilters() {
      this.stringFilters = ''
      this.loadFilters()
      this.loadStringFilters = false
      this.index()
    },
    resume() {
      this.eventHub.$emit('user-workload-to-company-modal', this.user)
    },
    incurredExpense (customerService) {
      this.eventHub.$emit('incurred-expense-modal', customerService)
    }
  }
}
</script>

<style scoped lang="sass">
.task-made-form
  margin-top: 10px

.input-form
  padding-right: 0

.time-form
  display: inline-block
  width: auto
  padding-left: 0

  input
    margin-left: 10px
    display: inline-block
    width: 60px

.tasks-table
  font-size: small

  td
    button
      margin-right: 3px

  tr
    max-height: 10px

  input
    font-size: small

.tasks-td-small
  min-width: 80px
  max-width: 110px
  white-space: nowrap

.tasks-td-large
  min-width: 200px
  max-width: 250px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
</style>
